import { type SxProps, type Theme } from "@mui/material";

import { DETAILS_SPACING } from "ui/dialog/dialog.constants";

export const FORM_SX: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: `${DETAILS_SPACING}px`,
};
